import { combineReducers } from 'redux';

import auditResults from './auditResults';

const assetAudit = combineReducers({
  auditResults,
});

export default assetAudit;
